import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues, FormControlProperties } from '@omegagrid/form';
import { msg } from "@omegagrid/localize";
import rp from '@reporting/rp-app-host';
import { ETLJob } from '@reporting/rp-types/jobs';

export class JobFormAdapter extends FormAdapter {

	constructor(
		private job: ETLJob = null,
		private jobNamePrefix: string = null
	) { super(); }

	getColumns() {
		return [
			{ width: 100 },
			{ width: null },
		];
	}

	async getControls() {
		let r = 0;
		const nameDefault = this.job ? this.job.job_name : (this.jobNamePrefix ? `${this.jobNamePrefix}_` : null);
		const controls: FormControlProperties[] = [
			{ row: r, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'job_name' },
			{ row: r++, col: 1, type: FormControlType.TextInput, key: 'job_name', value: nameDefault, required: true },
			{ row: r, col: 0, type: FormControlType.Label, value: msg('Description'), for: 'description' },
			{ row: r++, col: 1, type: FormControlType.TextInput, key: 'description', value: this.job?.description || null },
			{ row: r, col: 0, type: FormControlType.Label, value: msg('Order'), for: 'ord_num' },
			{ row: r++, col: 1, type: FormControlType.NumericInput, key: 'ord_num', value: this.job?.ord_num || null },
			{ row: r, col: 0, type: FormControlType.Label, value: msg('Enabled'), for: 'enabled' },
			{ row: r++, col: 1, type: FormControlType.Checkbox, key: 'enabled', value: this.job?.enabled || false },
		];
		return controls;
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: ["save", "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		const data: ETLJob = {
			idz: this.job?.idz || null,
			job_name: formValues.job_name as string,
			description: formValues.description as string,
			ord_num: formValues.ord_num as number,
			enabled: formValues.enabled as boolean
		};
		await rp.ms('jobs').post('jobs', Object.assign({ _job_name: this.job?.job_name || null }, data))
		return true;
	}

};
